import VendorOrganizationForm from "./VendorOrganizationForm";

const VendorTeamManagement = ({ type = "vendor" }) => (
  <VendorOrganizationForm type={type} mode="manage" showTeamTab />
);

export default VendorTeamManagement;
